import React from "react";
import { Col, Form, Row } from "react-bootstrap";

import { useTournamentContext } from "../contexts/Tournament";
import { ChildTournamentTeams } from "../types/tournament";

import { displayFormAlert } from "../../../../../lib/utils";
import { ITournament } from "../../../../../types/api";

export const useBuildTeamCities = ({ teams }: ChildTournamentTeams) => {
    const { methods, tournament: childTournament } = useTournamentContext();
    const tournament = childTournament as ITournament;

    return teams?.map((t, idx) => {
        const teamCity = tournament.schedulingData.teamCities.reduce(
            (acc, teamCity) => {
                const teamId = t.value.toString();
                if (teamCity[teamId]) {
                    acc = teamCity[teamId];
                }
                return acc;
            },
            "",
        );

        return (
            <Form.Group key={idx} className="team" as={Row}>
                <Form.Label column md={6}>
                    {t.label}
                </Form.Label>
                <Col md={6}>
                    <Form.Control
                        {...methods.register(`teamCities.${t.value}.city`)}
                        type="text"
                        defaultValue={teamCity}
                        placeholder="Enter Team City"
                        aria-invalid={
                            methods.formState.errors.teamCities?.[t.value]
                                ? "true"
                                : "false"
                        }
                    />
                    {methods.formState.errors.teamCities?.[t.value] &&
                        displayFormAlert({
                            level: "danger",
                            text: methods.formState.errors.teamCities[t.value]
                                ?.city?.message as string,
                        })}
                </Col>
            </Form.Group>
        );
    });
};
